/* eslint-disable @typescript-eslint/no-explicit-any */
import { Col, Row } from "antd";
import { SelectField } from "../../../../../../atoms/FormFields";

export default function ProductionTeams(props: any) {
  const { control, fields, errors, productionListDropdown, crewListDropdown } =
    props;

  return (
    <>
      {fields?.length > 0 ? (
        <>
          {fields.map((item: any, ind: number) => (
            <Row
              gutter={16}
              key={item?.id}
              style={{ display: "flex", alignItems: "center" }}
              className="assign_prod_items_row"
            >
              <Col span={8}>
                <div className="serviceLineSelected">
                  <p>
                    <span
                      style={{
                        backgroundColor: "#00A07D",
                        borderRadius: "100px",
                        height: "12px",
                        width: "12px",
                        display: "inline-block",
                        marginRight: "8px",
                      }}
                    ></span>
                    {item?.name}
                  </p>
                </div>
              </Col>
              <Col span={8} className="mb-0">
                <SelectField
                  fieldName={`production.${ind}.production_manager_id`}
                  label=""
                  control={control}
                  selectOption={productionListDropdown || []}
                  iProps={{
                    placeholder: "Select manager",
                  }}
                  isRequired
                  rules={{
                    required: "Manager is required.",
                  }}
                  validate={
                    Object.entries(errors).length > 0 &&
                    errors?.production &&
                    errors?.production[ind]?.production_manager_id
                      ? "error"
                      : undefined
                  }
                  validMessage={
                    Object.entries(errors).length > 0 &&
                    errors?.production &&
                    errors?.production[ind]?.production_manager_id
                      ? errors?.production[ind]?.production_manager_id?.message
                      : undefined
                  }
                />
              </Col>
              <Col span={8} className="mb-0">
                <SelectField
                  fieldName={`production.${ind}.crew_id`}
                  label=""
                  control={control}
                  selectOption={crewListDropdown || []}
                  iProps={{
                    placeholder: "Select crew",
                  }}
                  isRequired
                  rules={{
                    required: "Crew is required.",
                  }}
                  validate={
                    Object.entries(errors).length > 0 &&
                    errors?.production &&
                    errors?.production[ind]?.crew_id
                      ? "error"
                      : undefined
                  }
                  validMessage={
                    Object.entries(errors).length > 0 &&
                    errors?.production &&
                    errors?.production[ind]?.crew_id
                      ? errors?.production[ind]?.crew_id?.message
                      : undefined
                  }
                />
              </Col>
            </Row>
          ))}
        </>
      ) : (
        <div className="whenEmpty">
          <h3> There are no service line </h3>
        </div>
      )}
    </>
  );
}
